<template>
  <BootstrapModal
    ref="modal"
    modalId="addUserModal"
    title="Add User"
    closeText="Close"
    confirmText="Add"
    @confirm="handleAddUser"
  >
    <template #body>
      <form @submit.prevent="handleAddUser">
        <div class="mb-3">
          <label class="form-label">Username:</label>
          <input
            type="text"
            class="form-control"
            v-model="user.name"
            :class="{ 'is-invalid': validationErrors.name }"
            @input="validationErrors.name = false"
          />
        </div>

        <div class="mb-3">
          <label class="form-label">Email:</label>
          <input
            type="email"
            class="form-control"
            v-model="user.email"
            :class="{ 'is-invalid': validationErrors.email }"
            @input="validationErrors.email = false"
          />
        </div>

        <div class="mb-3">
          <label class="form-label">Password:</label>
          <input
            type="password"
            class="form-control"
            v-model="user.password"
            :class="{ 'is-invalid': validationErrors.password }"
            @input="validationErrors.password = false"
          />
        </div>

        <div class="mb-3">
          <label class="form-label">Confirm Password:</label>
          <input
            type="password"
            class="form-control"
            v-model="confirmPassword"
            :class="{ 'is-invalid': validationErrors.confirmPassword }"
            @input="validationErrors.confirmPassword = false"
          />
        </div>

        <div class="mb-3">
          <label class="form-label">Role:</label>
          <select
            class="form-select"
            v-model="user.role_id"
            :class="{ 'is-invalid': validationErrors.role_id }"
            @change="validationErrors.role_id = false"
          >
            <option value="" disabled>Select a role</option>
            <option
              v-for="role in filteredRoles"
              :key="role.id"
              :value="role.id"
            >
              {{ role.display_name }}
            </option>
          </select>
        </div>

        <div v-if="selectedRoleName === 'device_maintainer'" class="mb-3">
          <label class="form-label">Select Device:</label>
          <select
            class="form-select"
            v-model="user.device_id"
            :class="{ 'is-invalid': validationErrors.device_id }"
            @change="validationErrors.device_id = false"
          >
            <option value="" disabled>Select device</option>
            <option
              v-for="device in devices"
              :key="device.id"
              :value="device.id"
            >
              {{ device.name }}
            </option>
          </select>
        </div>
      </form>
    </template>
  </BootstrapModal>
</template>
  
  <script>
import BootstrapModal from "@/components/Common/BootstrapModal.vue";
import userService from "@/services/userService";
import emitter from "@/eventBus";

export default {
  name: "AddUserModal",
  props: {
    roles: {
      type: Array,
      required: true,
    },
    devices: {
      type: Array,
      required: true,
    },
  },
  components: { BootstrapModal },
  emits: ["user-added"],
  data() {
    return {
      user: {
        name: "",
        email: "",
        password: "",
        confirmPassword: "",
        role_id: null,
        device_id: null,
      },
      confirmPassword: "",
      validationErrors: {
        name: false,
        email: false,
        password: false,
        confirmPassword: false,
        role_id: false,
        device_id: false,
      },
    };
  },
  computed: {
    selectedRoleName() {
      const selected = this.roles.find(r => r.id === this.user.role_id);
      return selected ? selected.name : null;
    },
    filteredRoles() {
      return this.roles.filter((role) => role.name !== "superuser");
    },
  },
  methods: {
    show() {
      this.resetForm();
      this.$refs.modal.show();
    },
    hide() {
      this.$refs.modal.hide();
    },
    resetForm() {
      this.user = {
        name: "",
        email: "",
        password: "",
      };
      this.confirmPassword = "";
      this.validationErrors = {
        name: false,
        email: false,
        password: false,
        confirmPassword: false,
      };
    },
    async handleAddUser() {
      const { name, email, password, role_id, device_id } = this.user;
      const confirmPassword = this.confirmPassword;
      const isDeviceMaintainer = this.selectedRoleName === 'device_maintainer';

      this.validationErrors = {
        name: !name,
        email: !email || !this.isValidEmail(email),
        password: !password,
        confirmPassword: password !== confirmPassword,
        role_id: !role_id,
        device_id: isDeviceMaintainer && !device_id,
      };

      if (Object.values(this.validationErrors).some(Boolean)) return;

      try {
        await userService.addUser(this.user);
        emitter.emit("show-toast", {
          message: `User "${name}" added successfully.`,
          type: "success",
        });
        this.$emit("user-added");
        this.hide();
      } catch (error) {
        console.error("Error adding user:", error);
      }
    },
    isValidEmail(email) {
      return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);
    },
  },
};
</script>
  